<div class="d-flex flex-center current-vendor-name">
    @if (currentPlaceName) {
        <span class="ml-2">{{ currentPlaceName }}</span>
    }
    @if (currentVendorName) {
        <span class="mx-1 text-muted">|</span>
        <span class="ml-2">{{ currentVendorName }}</span>
    }
</div>